var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card page-max" },
        [
          _c(
            "div",
            {
              staticClass: "card-header",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "header-title" }, [
                _vm._v(
                  _vm._s(_vm.$route.params.id != 0 ? "编辑表单" : "新增表单")
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "ruleForm",
              staticClass: "form-container",
              attrs: { model: _vm.ruleForm, "label-width": "150px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("基本信息"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "表单名称：",
                        prop: "title",
                        rules: [
                          {
                            required: true,
                            message: "请填写表单名称",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: "请填写表单名称",
                          maxlength: "100",
                        },
                        model: {
                          value: _vm.ruleForm.title,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "title", $$v)
                          },
                          expression: "ruleForm.title",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "启用状态：",
                        prop: "status",
                        rules: [
                          {
                            required: true,
                            message: "请选择启用状态",
                            trigger: ["blur", "change"],
                          },
                        ],
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.ruleForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "status", $$v)
                            },
                            expression: "ruleForm.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("启用"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("禁用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "用户提交表单限制：", prop: "userLimit" },
                    },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          placeholder: "请输入",
                          maxlength: "100",
                        },
                        model: {
                          value: _vm.ruleForm.userLimit,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "userLimit", $$v)
                          },
                          expression: "ruleForm.userLimit",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-tip" }, [
                        _vm._v("小于0为不限制"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "总数限制：", prop: "totalLimit" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 0,
                          placeholder: "请输入",
                          maxlength: "100",
                        },
                        model: {
                          value: _vm.ruleForm.totalLimit,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "totalLimit", $$v)
                          },
                          expression: "ruleForm.totalLimit",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-tip" }, [
                        _vm._v("小于0为不限制"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "表单描述：", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          resize: "none",
                          placeholder: "请填写表单描述",
                        },
                        model: {
                          value: _vm.ruleForm.remark,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "remark", $$v)
                          },
                          expression: "ruleForm.remark",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("订单配置"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "是否插入订单中：", prop: "insertOrder" },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          model: {
                            value: _vm.ruleForm.insertOrder,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "insertOrder", $$v)
                            },
                            expression: "ruleForm.insertOrder",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("是"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("否"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.ruleForm.insertOrder === 1
                    ? [
                        _c(
                          "el-form-item",
                          { attrs: { label: "订单类型：", prop: "orderType" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { size: "small" },
                                model: {
                                  value: _vm.ruleForm.orderType,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "orderType", $$v)
                                  },
                                  expression: "ruleForm.orderType",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("普通订单"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          {
                            attrs: { label: "指定商品：", prop: "allProducts" },
                          },
                          [
                            _c(
                              "el-radio-group",
                              {
                                attrs: { size: "small" },
                                on: { change: _vm.handleProductTypeChange },
                                model: {
                                  value: _vm.ruleForm.allProducts,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.ruleForm, "allProducts", $$v)
                                  },
                                  expression: "ruleForm.allProducts",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 0 } }, [
                                  _vm._v("所有商品"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("指定SKU"),
                                ]),
                                _vm._v(" "),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("指定分类"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm.ruleForm.allProducts === 1
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "选择SKU：",
                                  prop: "specifiedProducts",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "product-selection" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "selected-products-header",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "selection-count" },
                                          [
                                            _vm._v("已选择 "),
                                            _c(
                                              "span",
                                              { staticClass: "count-num" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.selectedProductsList
                                                      .length
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" 个商品"),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("el-button", {
                                          attrs: {
                                            type: "primary",
                                            size: "small",
                                            icon: "el-icon-plus",
                                            circle: "",
                                          },
                                          on: { click: _vm.openSelectProducts },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.selectedProductsList.length > 0
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "selected-products-list",
                                          },
                                          [
                                            _c(
                                              "el-table",
                                              {
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  data: _vm.selectedProductsList,
                                                  border: "",
                                                  size: "mini",
                                                },
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "id",
                                                    label: "ID",
                                                    width: "80",
                                                    align: "center",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "image",
                                                    label: "商品图片",
                                                    width: "80",
                                                    align: "center",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            scope.row.image
                                                              ? _c("el-image", {
                                                                  staticStyle: {
                                                                    width:
                                                                      "40px",
                                                                    height:
                                                                      "40px",
                                                                  },
                                                                  attrs: {
                                                                    src: scope
                                                                      .row
                                                                      .image,
                                                                    fit: "cover",
                                                                    "preview-src-list":
                                                                      [
                                                                        scope
                                                                          .row
                                                                          .image,
                                                                      ],
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    2683095168
                                                  ),
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "skuCode",
                                                    label: "SKU编码",
                                                    "min-width": "120",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "skuName",
                                                    label: "商品名称",
                                                    "min-width": "200",
                                                    "show-overflow-tooltip": "",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    prop: "otPrice",
                                                    label: "价格",
                                                    width: "100",
                                                    align: "center",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "操作",
                                                    width: "100",
                                                    fixed: "right",
                                                    align: "center",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function (scope) {
                                                          return [
                                                            _c(
                                                              "el-tooltip",
                                                              {
                                                                attrs: {
                                                                  content:
                                                                    "删除",
                                                                  placement:
                                                                    "top",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    attrs: {
                                                                      type: "danger",
                                                                      icon: "el-icon-delete",
                                                                      size: "mini",
                                                                      circle:
                                                                        "",
                                                                    },
                                                                    nativeOn: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.handleRemoveProduct(
                                                                            scope.$index,
                                                                            scope.row
                                                                          )
                                                                        },
                                                                    },
                                                                  }
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ]
                                                        },
                                                      },
                                                    ],
                                                    null,
                                                    false,
                                                    1570177316
                                                  ),
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "no-products" },
                                          [
                                            _c("i", {
                                              staticClass: "el-icon-goods",
                                            }),
                                            _vm._v(" "),
                                            _c("span", [
                                              _vm._v(
                                                "暂无选择商品，请点击上方按钮添加"
                                              ),
                                            ]),
                                          ]
                                        ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.ruleForm.allProducts === 2
                          ? _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "选择分类：",
                                  prop: "specifiedCategories",
                                },
                              },
                              [
                                _c("el-cascader", {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择分类",
                                    options: _vm.categoryOptions,
                                    props: {
                                      children: "child",
                                      label: "name",
                                      value: "id",
                                      multiple: true,
                                    },
                                    clearable: "",
                                  },
                                  on: { change: _vm.handleCategoryChange },
                                  model: {
                                    value: _vm.selectedCategories,
                                    callback: function ($$v) {
                                      _vm.selectedCategories = $$v
                                    },
                                    expression: "selectedCategories",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c("div", { staticClass: "section-title" }, [
                    _vm._v("表单内容"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "表单内容：", prop: "formLists" } },
                    [
                      _c("FormEdit", {
                        ref: "FormEditRef",
                        attrs: { formConfig: _vm.formConfig },
                        model: {
                          value: _vm.ruleForm.formLists,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "formLists", $$v)
                          },
                          expression: "ruleForm.formLists",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-form-item", [
                _c(
                  "div",
                  { staticClass: "form-buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          loading: _vm.loading,
                          icon: "el-icon-check",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.handerSubmit("ruleForm")
                          },
                        },
                      },
                      [_vm._v("确认提交")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-back" },
                        on: { click: _vm.goReturn },
                      },
                      [_vm._v("返回列表")]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("SelectProducts", {
        ref: "SelectProductsRef",
        attrs: { selectType: 2, value: _vm.selectedProductsList, fromType: 1 },
        on: { input: _vm.handleSelectedProducts },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }